import { useEffect } from "react";
import {
  getPodadoresHandler,
  getPodadoresPublicHandler,
} from "../../../handlers/podadores.handler";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import Loading from "../../../components/Loading";
import { usePodadoresStore } from "../../../store/podadoresStore";
import { Container, Table } from "../../../components";
import useWindowSize from "../../../hooks/useWindowSize";
import { dataTable } from "./handlers";

const ListaPodadores = () => {
  const size = useWindowSize();
  const { loads } = useGeneralAppStore();
  const { podadores } = usePodadoresStore();
  useEffect(() => {
    if (podadores.length == 0) {
      getPodadoresPublicHandler();
    }
  }, [podadores]);

  return (
    <div style={{ paddingTop: size.width >= 576 && "5vh" }}>
      <Container size={"sm"}>
        <div
          className="position-relative"
          style={{ minHeight: size.width >= 576 ? "80vh" : "95vh" }}
        >
          <h4 className="text-center">Listado de podadores</h4>

          {loads.includes("podadores") ? (
            <div
              className={`position-absolute w-100 h-100 d-flex justify-content-center align-items-center`}
            >
              <Loading />
            </div>
          ) : (
            <Table height={`${size.width >= 576 ? "80vh" : "90vh"}`} data={dataTable(podadores)} />
          )}
        </div>
      </Container>
    </div>
  );
};

export default ListaPodadores;
